import { State } from './State';
import { StateValidator } from './StateValidator';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { TriggerNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/TriggerNode';
import { BranchControlNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/BranchControlNode';
import { uuid } from 'utils';
import { NodeIds, NodeTypeKeys } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';
import { BranchNameNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/BranchNameNode';
import { DisplayWebContentNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/DisplayWebContentNode';
import { SendEmailNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/SendEmailNode';
import { EndOfFlowNode } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Entities/Nodes/EndOfFlowNode';

export interface BranchedStateValidatorModel {
  showSegmentationSplit: boolean;
}

export class BranchedStateValidator implements StateValidator {
  public constructor(private campaignResponse: BranchedStateValidatorModel) {}

  public validate(): boolean {
    return this.campaignResponse.showSegmentationSplit;
  }
}

export interface BranchedStateModel {
  onsiteMessageSegments?: {
    segmentId: string;
    branchId: string;
    splitTestData?: {
      splitTestEnabled: boolean;
    };
    variants: { id: string }[];
    offsiteMessageSegments?: {
      variants: { id: string }[];
    }[];
  }[];
}

export class BranchedState implements State {
  public constructor(private validator: StateValidator, private model: BranchedStateModel) {}

  public createCanvas(): Canvas {
    if (!this.validator.validate()) {
      return;
    }

    const canvas = Canvas.createEmptyFlow(c => {
      const triggerRoot = new TriggerNode();

      const branchControlNode = new BranchControlNode(NodeIds.branchControl, NodeTypeKeys.displayWebContentNodeType);

      triggerRoot.setNextNode(branchControlNode);

      this.model.onsiteMessageSegments.forEach(onsiteSegment => {
        const branchRoot = new BranchNameNode(onsiteSegment.branchId, NodeTypeKeys.displayWebContentNodeType);

        if (onsiteSegment.splitTestData?.splitTestEnabled) {
          branchRoot.setNextNode(new DisplayWebContentNode(onsiteSegment.segmentId), false);
        } else {
          onsiteSegment.variants?.forEach(onsiteMessage => {
            branchRoot.setNextNode(new DisplayWebContentNode(onsiteMessage.id), false);
          });
        }

        onsiteSegment.offsiteMessageSegments?.forEach(offsiteSegment => {
          offsiteSegment.variants.forEach(offsiteMessage =>
            branchRoot.setNextNode(new SendEmailNode(offsiteMessage.id), false),
          );
        });

        branchRoot.setNextNode(new EndOfFlowNode(uuid()));

        branchControlNode.createBranch(branchRoot);
      });

      return triggerRoot;
    });

    return canvas;
  }
}
